// Logika kalkulator — meniru rumus persis dari workbook Excel CuanTrader.

export interface LotCalcInput {
  equity: number;
  riskPct: number;       // 0.02 = 2%
  slPips: number;
  side: 'BUY' | 'SELL';
  entry?: number | null;
  pipValue: number;      // $ per pip per 1.00 lot
  sustainMinPips: number;// ketahanan dana minimal (pips)
  lotMin: number;        // lot minimum broker
  pipSize: number;       // harga per 1 pip
}

const roundDown = (x: number) => Math.floor(x + 0.000001);

export function calcLot(i: LotCalcInput) {
  const risk$ = i.equity * i.riskPct;
  const lotRisk = i.slPips > 0 ? risk$ / (i.slPips * i.pipValue) : 0;
  // lot maksimal agar equity sanggup menahan 'sustainMinPips' pips (instrument-agnostic lewat pip_value)
  const lotSustain = i.sustainMinPips > 0 ? i.equity / (i.sustainMinPips * i.pipValue) : 0;
  const lotFinal = roundDown(Math.min(lotRisk, lotSustain) / i.lotMin) * i.lotMin;
  const limiter = lotRisk <= lotSustain ? 'Risk per trade' : 'Ketahanan dana';
  const canEntry = lotFinal >= i.lotMin;
  const status = canEntry
    ? 'OK — boleh entry bila Killer Setup lengkap'
    : 'JANGAN ENTRY — lot di bawah minimum (SL terlalu lebar / equity terlalu kecil)';
  const riskActual$ = lotFinal * i.slPips * i.pipValue;
  const riskActualPct = i.equity > 0 ? riskActual$ / i.equity : 0;
  const tpPips = i.slPips;
  const profitTP$ = lotFinal * tpPips * i.pipValue;
  const sustainFinalPips = lotFinal > 0 ? i.equity / (lotFinal * i.pipValue) : null;
  let slPrice: number | null = null;
  let tpPrice: number | null = null;
  if (i.entry != null && i.entry !== 0 && canEntry) {
    slPrice = i.side === 'BUY' ? i.entry - i.slPips * i.pipSize : i.entry + i.slPips * i.pipSize;
    tpPrice = i.side === 'BUY' ? i.entry + tpPips * i.pipSize : i.entry - tpPips * i.pipSize;
  }
  return {
    risk$: round2(risk$),
    lotRisk: round4(lotRisk),
    lotSustain: round4(lotSustain),
    lotFinal: round2(lotFinal),
    limiter,
    canEntry,
    status,
    riskActual$: round2(riskActual$),
    riskActualPct: round4(riskActualPct),
    tpPips,
    profitTP$: round2(profitTP$),
    sustainFinalPips: sustainFinalPips == null ? null : Math.round(sustainFinalPips),
    slPrice: slPrice == null ? null : round2(slPrice),
    tpPrice: tpPrice == null ? null : round2(tpPrice),
  };
}

export interface SustainInput {
  equity: number;
  lotOpen: number;
  side: 'BUY' | 'SELL';
  priceNow: number;
  defensePrice: number;
  contractSize: number;  // 100 (XAU)
  pipsPerPoint: number;  // 10
  lotMin: number;        // 0.01
}

export function calcSustain(i: SustainInput) {
  const sustainNowPoint = i.lotOpen > 0 ? i.equity / (i.lotOpen * i.contractSize) : 0;
  const sustainNowPips = sustainNowPoint * i.pipsPerPoint;
  const distancePoint = Math.abs(i.defensePrice - i.priceNow);
  const equityDivDist = distancePoint > 0 ? i.equity / distancePoint : 0;
  const lotMax = roundDown(equityDivDist / i.contractSize / i.lotMin) * i.lotMin;
  const lotHedge = Math.max(0, round2(i.lotOpen - lotMax));
  const hedgeDir =
    lotHedge === 0
      ? 'Tidak perlu hedging — akun aman sampai harga pertahanan'
      : i.side === 'BUY'
      ? 'Buka SELL'
      : 'Buka BUY';
  return {
    sustainNowPoint: round2(sustainNowPoint),
    sustainNowPips: Math.round(sustainNowPips),
    distancePoint: round2(distancePoint),
    equityDivDist: round4(equityDivDist),
    lotMax: round2(lotMax),
    lotHedge,
    hedgeDir,
  };
}

function round2(x: number) { return Math.round(x * 100) / 100; }
function round4(x: number) { return Math.round(x * 10000) / 10000; }
